import { connect } from "react-redux";

import App from "./App";
import { userLogin, userLogout } from "./actions/index";
import { setGameData, randomizedGameData, addGamePoints, reduceGamePoints, setShouldRewardPoints, setGameAwardRewardStatus, resetGameStatus } from "./actions/game";

const mapStateToProps = state => ({
  sounds: state.audio.sounds,
  angle: state.angle,
  quizQuestions: state.quizQuestions,
  gameData: state.game.data,
  gamePoints: state.game.points,
  shouldRewardPoints: state.game.shouldRewardPoints,
  gameStatus: state.game.status,
});

const mapDispatchToProps = dispatch => ({
  userLogin: login => {
    dispatch(userLogin(login));
  },
  userLogout: () => {
    dispatch(userLogout());
  },
  setGameData: data => {
    dispatch(setGameData(data));
  },
  randomizedGameData: () => {
    dispatch(randomizedGameData());
  },
  addGamePoints: data => {
    dispatch(addGamePoints(data));
  },
  reduceGamePoints: data => {
    dispatch(reduceGamePoints(data));
  },
  setShouldRewardPoints: data => {
    dispatch(setShouldRewardPoints(data));
  },
  setGameAwardRewardStatus: () => {
    dispatch(setGameAwardRewardStatus());
  },
  resetGameStatus: () => {
    dispatch(resetGameStatus());
  }
});

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/AppContainer.js